import React, { useEffect, useState } from "react";
import axios from 'axios';
import headers from "../utils/stocks";
import { NumericFormat } from 'react-number-format';

function StockItem({ param }) {
    const [stock, setStock] = useState(null);
    const baseUrl = `https://trading-view.p.rapidapi.com/stocks/get-financials?columns=${param.columns}&screenerName=${param.screenerName}&lang=${param.lang}&symbol=${param.symbol}`;
    const link = `https://www.tradingview.com/chart/?symbol=IDX%3A${param.name}`
    useEffect(() => {
        axios.get(baseUrl, {headers}).then((response) => {
            setStock(response.data)
        })
    }, [baseUrl]);
    if(stock == null) return null;
    return (
        <li>
            <div className="list_inner">
                <div className="price">
                    <h3><span>{stock.data[0].d[2]}<span className="currency"></span></span></h3>
                </div>
                <div className="plan">
                    <h3>IDX {param.name}</h3>
                </div>
                <ul className="item">
                    <li className="active">
                        <p>Volume : <NumericFormat value={stock.data[0].d[1]} displayType={'text'} thousandSeparator={true} /></p>
                    </li>
                    <li className="active">
                        <p>Last Price : {stock.data[0].d[2]}</p>
                    </li>
                    <li className="active">
                        <p>Open Price : {stock.data[0].d[3]}</p>
                    </li>
                </ul>
                <div className="tokyo_tm_button" data-position="left">
                    <a href={link} target="_blank" rel="noreferrer"><span>See Details</span></a>
                </div>
            </div>
        </li>
    );
}

export default StockItem;